import { Box } from "@drone-js/core";
import { type FunctionComponent, memo } from "react";
import BrandLogo, { type IBrandLogo } from "./BrandLogo";
import { brandArray } from "./constants/brandsInfo";

interface BrandsProps {
    brands?: string[];
}

const BrandsComponent: FunctionComponent<BrandsProps> = () => (
    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
        {brandArray?.map((brand: IBrandLogo) => (
            <BrandLogo key={brand.alt} {...brand} />
        ))}
    </Box>
);

const BrandList = memo(BrandsComponent);

export default BrandList;
